export default __webpack_public_path__ + "static/media/not-right.72dcb561.svg";